export default "__VITE_ASSET__CSLewJyz__"